import React, { useState } from "react";
import "./styles.scss";
import { TextLink } from "@trussle/external-components";
import cn from "classnames";
import useOnClickOutside from "use-onclickoutside";
import { ILink } from "../../templates/ModularTemplate/types";
import arrowForward from "./arrow-forward.svg";
import arrowForwardOrange from "./arrow-forward-orange.svg";
import arrowForwardGreen from "./arrow-forward-green.svg";

export interface IFloatingButton {
    buttonText: string;
    applyLinks?: ILink[];
}

const hasHover = () => window.matchMedia("(hover: hover)").matches;
const FloatingButton: React.FC<IFloatingButton> = ({ buttonText, applyLinks }) => {
  const isButtonWithTwoLinks = applyLinks && applyLinks.length > 1;
  let remortgageLink;
  let purchaseLink;
  if (applyLinks && applyLinks?.length > 1) {
    remortgageLink = applyLinks[0].url;
    purchaseLink = applyLinks[1].url;
  }
  const ref = React.useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  const expand = (e: React.MouseEvent<HTMLElement>) => {
    if (!isExpanded) {
      e.stopPropagation();
      setIsExpanded(true);
    }
  };
  const expandHover = (e: React.MouseEvent<HTMLElement>) => {
    if (hasHover()) {
      expand(e);
    }
  };
  const close = () => {
    if (isExpanded) {
      setIsExpanded(false);
    }
  };
  const closeHover = () => {
    if (hasHover()) {
      close();
    }
  };
  const handleRedirect = (url?: string) => (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (url) {
      window.location.assign(url);
    }
  };
  useOnClickOutside(ref, close);

  return (
    <div
      onClickCapture={expand}
      onMouseLeave={closeHover}
      onBlur={closeHover}
      onMouseOverCapture={expandHover}
      key="floating-btn"
      className={cn("floating-btn", {
        "with-two-links": isButtonWithTwoLinks,
        "with-one-link": !isButtonWithTwoLinks,
        expanded: isExpanded,
      })}
      ref={ref}
    >
      <p className={cn({ "not-expanded": !isButtonWithTwoLinks })}>
        {isButtonWithTwoLinks
          ? (
            <span className="floating-btn-title">
              {buttonText}
              <img className="floating-btn-title-arrow" src={arrowForward} alt="arrow-forward" />
            </span>
          )
          : (
            <TextLink
              href={!isButtonWithTwoLinks ? applyLinks && applyLinks[0].url : undefined}
              className={!isButtonWithTwoLinks ? "floating-btn-with-one-link" : undefined}
            >
              {buttonText}
              <img className="floating-btn-title-arrow" src={arrowForward} alt="arrow-forward" />
            </TextLink>
          )}

      </p>
      {(isButtonWithTwoLinks) && (
        <span className="floating-btn-links">
          <div className="floating-btn-purchase">
            <span
              onClickCapture={handleRedirect(purchaseLink)}
            >
              Purchase
            </span>
            <span className="floating-btn-purchase-arrow">
              <img className="floating-btn-purchase-arrow" src={arrowForwardOrange} alt="arrow" />
            </span>
          </div>
          <div className="floating-btn-remortgage">
            <span
              onClickCapture={handleRedirect(remortgageLink)}
            >
              Remortgage
            </span>
            <span className="floating-btn-remortgage-arrow">
              <img src={arrowForwardGreen} alt="arrow" />
            </span>
          </div>
        </span>
      )}
    </div>
  );
};

export default FloatingButton;
